export default __webpack_public_path__ + "static/regentLogo-5c603ba9bc9f8baedeae45630b94834d.png";